import { Stack, Text } from '@mantine/core';
import type { CalendarPlatform } from 'src/meetings/models';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { CalendarAccountCard } from './CalendarAccountCard';
import { useStartCalendarOAuthMutation } from 'src/meetings/hooks/useStartCalendarOAuthMutation';

const availableCalendars: Array<{
  platform: CalendarPlatform;
  title: string;
  connectText: string;
}> = [
  { platform: 'GOOGLE', title: 'Google calendar', connectText: 'Connect Google' },
  { platform: 'MICROSOFT', title: 'Outlook calendar', connectText: 'Connect Outlook' },
];

type Props = {
  showTitle?: boolean;
};

export const AddCalendarsListComponent = ({ showTitle = true }: Props) => {
  const { startOAuth, isLoading: isStarting } = useStartCalendarOAuthMutation();

  const handleStartAuth = async (platform: CalendarPlatform) => {
    try {
      const { url } = await startOAuth(platform);
      window.location.href = url;
    } catch (error) {
      notifyAndLogError('Failed to connect calendar', 'Please try again later.', error);
    }
  };

  return (
    <Stack gap="xs">
      {showTitle && (
        <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.10">
          Connect more calendars
        </Text>
      )}
      <Stack gap="xs">
        {availableCalendars.map(calendar => (
          <CalendarAccountCard
            key={calendar.platform}
            platform={calendar.platform}
            title={calendar.title}
            connectText={calendar.connectText}
            onConnect={() => handleStartAuth(calendar.platform)}
            disabled={isStarting}
          />
        ))}
      </Stack>
    </Stack>
  );
};
